<template>
    <b-row no-gutters
           id="dashboard_panel_component"
           class="dashboard-panel-component">
        <b-col lg="4" cols="6"
               class="dashboard-panel-element"
               :class="{'small': item.small}"
               v-for="(item, index) in panel"
               :key="index">
            <router-link :to="{ name: item.path }" class="dashboard-panel-element-inner" v-if="item.path">
                <div class="dashboard-panel-element-label" v-html="item.label"></div>
                <div class="dashboard-panel-element-value" v-html="item.value"></div>
                <i class="dashboard-panel-element-value mdi mdi-help-circle"
                   v-if="item.info"
                   title="The amount has been transferred to FutureNet. 10% of all your income from the Futuro Network is going to the FutureNet Product Packs. You get Media Points at your account for it.Here you can see the total amount since your start in the Futuro Network."
                   v-tippy="{ placement : 'top',  arrow: true }"></i>
            </router-link>
            <div class="dashboard-panel-element-inner" v-else>
                <div class="dashboard-panel-element-label" v-html="item.label"></div>
                <div class="dashboard-panel-element-value" v-html="item.value"></div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        dependencies: ['money'],
        computed: {
            panel() {

                let unilevelTeam = this.$store.getters.user.unilevelTeam

                return {
                    startPacket: {
                        label: 'My start<br>package',
                        value: 'FND ' + this.money.packageFormat(this.$store.getters.user.position, 'fnd'),
                        path: 'MyStartPacket'
                    },
                    careerLevel: {
                        label: 'My career<br>level',
                        value: this.$store.getters.user.careerLevel,
                        path: 'BusinessQualifications'
                    },
                    matchingBonus: {
                        label: 'My matching<br>bonus',
                        value: this.$store.getters.user.matchingBonus + '%',
                        path: 'BusinessQualifications'
                    },
                    unilevel: {
                        label: 'My Unilevel<br>Team',
                        value: unilevelTeam + '<br>' + (unilevelTeam === 1 ? 'Member' : 'Members'),
                        path: 'MyTeam'
                    },
                    sponsor: {
                        label: 'Futuro Sponsor<br>System',
                        value: 'COMING<BR>SOON!',
                        path: 'SponsorSystem'
                    },
                    matrixes: {
                        label: 'The amount transferred to FutureNet Products Packs FND 1000',
                        value: 'FND ' + this.money.format(this.$store.getters.user.future_net_upgrade_account_balance, 'fnd'),
                        info: true,
                        path: 'FNProductPacks',
                        small: true
                    },
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../assets/scss/_colors.scss';

    .dashboard-panel-element{
        transition: 200ms all linear;
        height: 208px;

         &:nth-child(1),
         &:nth-child(6){
            background-color: #4ab7b9;
         }

         &:nth-child(2),
         &:nth-child(4){
             background-color: #00b1b9;
         }

         &:nth-child(3),
         &:nth-child(5){
             background-color: #009ea5;
         }

        &:hover,
        &:focus{
            background-color: $op;

            a{
                text-decoration: none;
            }
        }
    }

    .dashboard-panel-element-inner{
        display: block;
        height: 100%;
        padding: 35px 35px 0;
    }

    .dashboard-panel-element-label{
        color: $white;
        font-size: 24px;
        line-height: 1.2;
        font-weight: bold;
        margin: 0 0 20px;
    }

    .small{
        .dashboard-panel-element-label{
            font-size: 18px;
        }
    }

    .dashboard-panel-element-value{
        color: $white;
        font-size: 22px;
        font-weight: bold;
        line-height: 1.2;
        text-transform: uppercase;
        float: left;

        + .dashboard-panel-element-value{
            margin-left: 11px;
        }
    }

    @media(max-width: 991px){
        .dashboard-panel-element{
            height: 130px;

            &:nth-child(1),
            &:nth-child(4){
            background-color: #4ab7b9;
            }

            &:nth-child(2),
            &:nth-child(5){
            background-color: #00b1b9;
            }

            &:nth-child(3),
            &:nth-child(6){
            background-color: #009ea5;
            }



            .dashboard-panel-element-inner{
                padding: 15px 15px 0;
            }

            .dashboard-panel-element-label{
                font-size: 18px;
                line-height: 1;
            }

            .dashboard-panel-element-value{
                font-size: 24px;
                line-height: 1;
            }

        }
    }

    @media(max-width: 767px){
        .dashboard-panel-element{
            .dashboard-panel-element-value{
                font-size: 18px;
                line-height: 1;
            }
        }
    }

    @media(max-width: 360px){
        .dashboard-panel-element{
            .dashboard-panel-element-label{
                font-size: 13px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/dashboard/DashboardPanel.vue